module.exports = __webpack_public_path__ + "static/media/Q&A.344989d6.PNG";